var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 30.6667L13.417 21.0834L16.1003 18.3042L21.0837 23.2875V7.66669H24.917V23.2875L29.9003 18.3042L32.5837 21.0834L23.0003 30.6667ZM11.5003 38.3334C10.4462 38.3334 9.54405 37.9583 8.79399 37.2083C8.04394 36.4582 7.66827 35.5555 7.66699 34.5V28.75H11.5003V34.5H34.5003V28.75H38.3337V34.5C38.3337 35.5542 37.9586 36.4569 37.2086 37.2083C36.4585 37.9596 35.5558 38.3346 34.5003 38.3334H11.5003Z",
    fill: "#093559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.37c5c3504370f7e7c14b4efbe91bf609.svg";
export { ForwardRef as ReactComponent };